import request from '@/utils/request'

/**
 * 邮件管理API
 *
 * @author Jay Qing
 */

const BASE_URL = 'common/mail'
export const MAIL_BASE_URL = 'common/mail'

/**
 * 分页查询接口
 *
 * @type {string}
 */
export const MAIL_PAGE_URL = `${BASE_URL}/page`

/**
 * 保存数据
 *
 * @param data 数据
 * @return {Promise} 结果
 */
export function save(data: any) {
  return request({
    url: BASE_URL,
    method: 'post',
    data: data
  })
}

/**
 * 删除指定ID的数据
 *
 * @param ids ID
 * @return {Promise} 结果
 */
export function remove(ids: any[]) {
  return request({
    url: BASE_URL,
    method: 'delete',
    data: ids
  })
}

/**
 * 更新指定ID的数据
 *
 * @param model 数据
 * @return {Promise} 结果
 */
export function update(model: any) {
  return request({
    url: BASE_URL,
    method: 'put',
    data: model
  })
}

/**
 * 查询指定ID的数据
 *
 * @param id ID
 * @return {Promise} 结果
 */
export function get(id: any) {
  return request(({
    url: BASE_URL + '/' + id,
    method: 'get'
  }))
}

/**
 * 分页查询
 *
 * @param query 查询条件
 * @return {Promise} 结果
 */
export function page(query: any) {
  return request({
    url: BASE_URL + '/page',
    method: 'get',
    params: query
  })
}

/**
 * 发送邮件
 *
 * @param mail 邮件信息
 * @return {Promise} 结果
 */
export function send(mail:any) {
  return request({
    url: BASE_URL + '/send',
    method: 'post',
    data: mail
  })
}

